module.exports = __webpack_public_path__ + "static/img/搜索.9193d04a.png";